<template>
    <div>
        <!-- LISTAGEM DE PRODUTOS SIMPLES -->
        <template v-for="product in products">
            <PurchaseItem
                v-if="showProductSimple(product)"
                :key="product.purchases_products_id"
                :product="product"
            />
        </template>

        <!-- LISTAGEM DE PRODUTOS DE CESTA -->
        <template v-for="product in listProductGroup">
            <PurchaseItem
                :key="product.purchases_products_id"
                :product="product"
                :children="product.children"
            />
        </template>

        <!-- LISTAGEM DE PRODUTOS COM ADICIONAIS -->
        <template v-for="product in listCartWithAdditionalProducts">
            <PurchaseItem
                :key="product.purchases_products_id"
                :product="product"
                :children="product.additional_products"
            />
        </template>
    </div>
</template>

<script>
import PurchaseItem from "../PurchaseItem";

export default {
    name: "PurchaseProducts",
    props: {
        products: {
            required: true
        },
        purchase: {
            required: true
        }
    },
    components: {
        PurchaseItem
    },
    methods: {
        showProductSimple(product) {
            return (
                !product.is_product_group &&
                !product.has_childs_additionals &&
                !product.uuid_item_father_cart
            );
        }
    },
    computed: {
        listProductGroup() {
            return this.purchase.cart
                ? JSON.parse(this.purchase.cart).father_list
                : [];
        },
        listCartWithAdditionalProducts() {
            return this.products?.filter(element => {
                element.additional_products = [];
                if (element?.has_childs_additionals) {
                    element.additional_products = this.products?.filter(
                        el => el.uuid_item_father_cart == element.uuid_item_cart
                    );
                    return element;
                }
            });
        }
    }
};
</script>
